module.exports = __webpack_public_path__ + "img/Cori_Pairing-Mode_Light_poster.5cb36ac5.png";